/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_First_Meeting_SubtitleInputs */



/**
* | output |
* | --- |
* | "Think of a conversation in the next few days that you would like to prepare with Wundo." |
*
* @param {Onboarding_First_Meeting_SubtitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_first_meeting_subtitle = /** @type {((inputs?: Onboarding_First_Meeting_SubtitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_First_Meeting_SubtitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Denk aan een gesprek in de komende dagen dat je graag met Wundo wil voorbereiden.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pensez à une conversation des prochains jours que vous aimeriez préparer avec Wundo.")
	return /** @type {LocalizedString} */ ("Think of a conversation in the next few days that you would like to prepare with Wundo.")
});